(function () {
    'use strict';

    angular
        .module('riskModule')
        .controller('SelectDepartmentRiskController', Controller);

    Controller.$inject = ['$scope', 'grcRiskService'];

    function Controller($scope, grcRiskService) {
        $scope.ctxSelectRisk = {};

        $scope.searchRisks = function () {
            var searchTerm = $scope.ctxSelectRisk.searchTerm;
            if (_.isUndefined(searchTerm) || searchTerm.length < 2) {
                $scope.availableRisks = [];
                return;
            }
            grcRiskService
                .searchDepartmentRisks(searchTerm)
                .then(function (foundRisks) {
                    $scope.availableRisks = _.filter(foundRisks.Results, {IsClosed: false});
                });
        }
    }
})();